// extracted by mini-css-extract-plugin
export var parasuccessstoriesinner = "ParagraphSuccessStories-module--parasuccessstoriesinner--edcc7";
export var parasuccessstoriesouter = "ParagraphSuccessStories-module--parasuccessstoriesouter--956ae";